import { render, staticRenderFns } from "./create-sub-task.vue?vue&type=template&id=3f9f0c45&scoped=true&"
import script from "./create-sub-task.vue?vue&type=script&lang=js&"
export * from "./create-sub-task.vue?vue&type=script&lang=js&"
import style0 from "./create-sub-task.vue?vue&type=style&index=0&id=3f9f0c45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9f0c45",
  null
  
)

export default component.exports